import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { OurProjectService } from '../../services/our-project.service';
import { OurProjectsModel } from '../../models/our-projects.model';
import { Lightbox } from 'ngx-lightbox';

@Component({
  selector: 'app-job-detail-three',
  templateUrl: './job-detail-three.component.html',
  styleUrls: ['./job-detail-three.component.css']
})
export class JobDetailThreeComponent implements OnInit{
Id = 0;
currentLang = localStorage.getItem('lang') || 'ar';

  constructor(private route: ActivatedRoute,private ourProjectService: OurProjectService,private lightbox: Lightbox){
     this.Id = +route.snapshot.paramMap.get("Id")!;
  }
  project:OurProjectsModel = {}
  ngOnInit(): void {
    if(this.Id > 0){
  this.ourProjectService.getById(this.Id).subscribe((res: any) => {
        this.project = res;
            this.project.Images?.forEach(element => {
            var img = { id: element.Id?.toString(), src: element.ImageUrl, thumb: element.ImageUrl, caption: ''}
            this._gallery.push(element)
    });
      });
    }
       
  }
   // Set Topbar Option
   Menuoption = 'job';
  Settingicon = true;
    _gallery: Array<any> = [];

    openGallery(index: any): void {
      // this._gallery = [];

    // this._gallery = [{ id: '1', src: 'assets/images/work/11.jpg', thumb: 'assets/images/work/11.jpg', caption: 'Work-image'},{ id: '1', src: 'assets/images/personal/6.jpg', thumb: 'assets/images/personal/6.jpg'}]
    this.lightbox.open(this._gallery, index, { disableScrolling: true, centerVertically: true, showZoom: false });
  }
}
